import { isInIframe, getQueryString } from '@umu/umu-dom';

// 父frame是否是课程
export const isParentLocationCourse = (parenInfo: {origin: string, pathname: string, href: string}): boolean => {
    const courseReg = /course/;
    const originReg = /umu./
    if (isInIframe()) {
        if (parenInfo?.href) {
            const {
                origin,
                pathname
            } = parenInfo;
            return courseReg.test(pathname) && originReg.test(origin) && isInIframe();
        } else {
            return true;
        }
    } else {
        return false;
    }
};

export const isParentLocationProgram = (): boolean => {
    return isInIframe() && getQueryString('parent') === 'program';
};

// url上明确带参数
export const isLandscapeByUrlQuery = (): boolean => {
    const isLandScapeQuery = (/pc_landscape/).test(location.href);
    const isMobileSite = /m\..*umu/.test(location.origin);
    return isLandScapeQuery && isMobileSite;
};
